// Before/after slider: range input drives a CSS variable.
document.querySelectorAll('[data-ba]').forEach((ba) => {
  const range = ba.querySelector('input[type=range]');
  const set = () => ba.style.setProperty('--pos', range.value + '%');
  range.addEventListener('input', set);
  set();
});

// Fit finder: sizes come from section blocks (data-sizes). No ranges set = email fallback.
document.querySelectorAll('[data-fit]').forEach((form) => {
  const sizes = JSON.parse(form.dataset.sizes || '[]');
  const out = form.querySelector('[data-fit-result]');
  const email = form.dataset.email;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const breed = form.breed.value.trim();
    const weight = parseFloat(form.weight.value);
    const waist = parseFloat(form.waist.value);
    if (!(weight > 0) || !(waist > 0)) {
      out.hidden = false;
      out.innerHTML = 'Enter your dog’s weight and waist measurement to see a size.';
      return;
    }
    // Waist decides first (fit), weight breaks ties; between sizes -> larger.
    const byWaist = sizes.filter((s) => waist >= s.waistMin && waist <= s.waistMax);
    const pick = (byWaist.length ? byWaist : sizes.filter((s) => weight >= s.weightMin && weight <= s.weightMax)).pop();

    const body = encodeURIComponent(`Breed: ${breed || '-'}\nWeight: ${weight} lb\nWaist: ${waist} in`);
    const mail = `mailto:${email}?subject=${encodeURIComponent('Which harness size?')}&body=${body}`;
    out.hidden = false;
    if (pick) {
      out.innerHTML = `<strong>Size ${pick.name}</strong>Recommended for ${weight} lb and a ${waist}" waist. Between sizes? Go one up.`;
      const radio = document.querySelector(`.sizes input[data-size="${pick.name}"]`);
      if (radio && !radio.disabled) radio.checked = true;
    } else {
      out.innerHTML = `<strong>We’ll size it for you</strong>Send us these measurements and we’ll reply with the right size, usually within a day. <a href="${mail}">Email your measurements</a>`;
    }
  });
});
